import { Component, OnInit } from '@angular/core';
import { SearchService } from '../../services/search.service';
import { ReportAuditRecord } from '../../models/report.model';
import { PublishedReportHistory } from '../../models/search.model';
import { environment } from '../../../environments/environment';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-version-history',
  templateUrl: './version-history.component.html',
  styleUrls: ['./version-history.component.css']
})
export class VersionHistoryComponent implements OnInit {
  versionList: PublishedReportHistory[] = [];
  filelocationapi: string = environment.apiEndpoint + "/Report/DownloadReportByPublishedReportHistoryId?id=";
  constructor(private searchService: SearchService,
    private datePipe: DatePipe) { }

  ngOnInit(): void {
  }

  ShowReportHistoryDlg(id:string)
  {
    this.searchService.getVersionHistory$(id).subscribe(resp => {
     //console.log(resp);
        this.versionList = resp;
    });
  }

}
